module.exports = __webpack_public_path__ + "static/img/mainTop.fba2685.jpg";


//////////////////
// WEBPACK FOOTER
// ./image/homePage/mainTop.jpg
// module id = 562
// module chunks = 502